import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { searchQuery } from './searchQuery.reducer';
import { employees } from './employees.reducer';
import { rooms } from './rooms.reducer';
import { scheduling } from './scheduling.reducer';
import { identity } from './identity.reducer';
import { menuReducers } from '../pages/Menus/duck/reducers';
import { newMenuReducers } from '../pages/NewMenu/duck/reducers';
import { editMenuReducers } from '../pages/EditMenu/duck/reducers';
import { galleryReducers } from '../pages/Gallery/duck/reducers';
import { roomGalleryReducers } from '../pages/RoomGallery/duck/reducers';
import { childGalleryReducers } from '../pages/ChildGallery/duck/reducers';
import { adminEntitiesReducers } from '../pages/Admin/Entities/duck/reducers';
import { adminCentersReducers } from '../pages/Admin/Centers/duck/reducers';
import { timeOffRequestReducers } from '../pages/Scheduling/timeOffDucks/reducers';
import { employeeScheduleReducers } from '../pages/Home/MySchedule/duck/reducers';
import { eventsReducers } from '../pages/Events/duck/reducers';
import { centerGalleryReducers } from '../pages/CenterGallery/duck/reducers';
import { messagingReducers } from '../pages/Messages/ducks/reducers';
import { employeeAttendanceReducers } from '../pages/Attendance/Employee/duck/reducers';
import { schedulingReducer } from '../pages/Scheduling/schedulingDucks/reducer';

const KangarootimeReducers = combineReducers({
  authentication,
  searchQuery,
  employees,
  rooms,
  scheduling_old: scheduling,
  identity,
  menus: combineReducers({
    info: menuReducers, // temp for now
    newMenu: newMenuReducers,
    edit: editMenuReducers
  }),
  gallery: combineReducers({
    byRoom: roomGalleryReducers,
    overview: galleryReducers,
    byChild: childGalleryReducers,
    byMonth: centerGalleryReducers
  }),
  scheduling: combineReducers({
    timeOffRequests: timeOffRequestReducers,
    schedules: schedulingReducer
  }),
  admin: combineReducers({
    entities: adminEntitiesReducers,
    centers: adminCentersReducers
  }),
  home: combineReducers({
    schedule: employeeScheduleReducers
  }),
  events: eventsReducers,
  messages: messagingReducers,
  attendance: combineReducers({
    employee: employeeAttendanceReducers
  })
});

const rootReducer = (state, action) => {
  // successful logout dispatched, need to reset the redux state and clear the persisted state
  if (action.type === 'LOGOUT') {
    state = undefined;
    localStorage.clear();
  }

  return KangarootimeReducers(state, action);
};

export default rootReducer;
